import { InspectionInterval, parseInspectionInterval } from 'types/fde'
import { parseBoolean, parseString } from 'utils/parsingHelpers'
import { compareAlphanumeric } from 'utils/stringHelpers'

import { GeckoEntryBase } from './geckoEntry'
import { RolodexEntryJson } from './rolodexEntryFields'

/**
 * A portion of a unit, such as waterwalls on a boiler, or the floor of a tank.
 */
export class GeckoComponent extends GeckoEntryBase<
  {
    name: string
    disable_3d: boolean
    inspection_interval: InspectionInterval
  },
  {
    organization: string
    site: string
    unit: string
  }
> {
  //----------------------------------------------------------------------------

  /**
   * A simple constructor, private so that a more descriptive factory method
   * (which can return undefined) is used instead
   * @param json The raw JSON to create an instance from
   * @private
   */
  private constructor(json: RolodexEntryJson) {
    //--------------------------------------------------------------------------

    super(
      json,
      {
        name: parseString(json.data.name) ?? json.id,
        disable_3d: parseBoolean(json.data.disable_3d) ?? false,
        inspection_interval:
          parseInspectionInterval(json.data.inspection_interval) ?? {},
      },
      {
        organization: parseString(json.tags.organization) ?? '',
        site: parseString(json.tags.site) ?? '',
        unit: parseString(json.tags.unit) ?? '',
      },
      {}
    )
  }

  //----------------------------------------------------------------------------

  /**
   * A simple factory method which creates a component from raw JSON
   * @param json The raw JSON to create an instance from
   * @constructor
   */
  public static CreateFromJSON(json: RolodexEntryJson) {
    return new GeckoComponent(json)
  }

  /**
   * A simple comparison method, used to sort entries by their names, properly
   * taking into account multi-digit numbers (i.e. 2 will appear before 20)
   * @param a     The first entry
   * @param b     The second entry
   */
  public static DefaultSort(a: GeckoComponent, b: GeckoComponent) {
    return compareAlphanumeric(a.data.name, b.data.name)
  }
}
